"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spaceCmds1arg = {
    kern: true,
    hskip: true,
    hspace: true,
    hphantom: true,
};
//# sourceMappingURL=space.js.map